import hyperdom from 'hyperdom'
import isScriptLoaded from 'root-core/isScriptLoaded.js'

export default class KnoCommerce {
  constructor ({config, quoteCriteria}) {
    this.id = config.knoCommerce.id
    this.accountId = config.knoCommerce.accountId
    this.enableForPaymentOptions = config.knoCommerce.enableForPaymentOptions
    this.quoteCriteria = quoteCriteria
    this.knoCommerceUrl = `https://www.knocdn.com/v1/embed.js?id=${this.id}`
  }

  init ({booking, tripDetails}) {
    const paymentDetails = tripDetails.payment

    let paymentMethod = ''
    if (paymentDetails.type === 'On request') {
      paymentMethod = 'onRequest'
    } else if (paymentDetails.type === 'On hold') {
      paymentMethod = 'onHold'
    } else {
      paymentMethod = paymentDetails.outstanding === 0 ? 'fullPayment' : 'depositPayment'
    }

    if (!this.enableForPaymentOptions[paymentMethod]) {
      return
    }

    this.setupConfig({booking, tripDetails})
    this.injectScript()
  }

  setupConfig ({booking, tripDetails}) {
    const leadPassenger = booking.leadPassenger
    const priceBreakdown = booking.priceBreakdown

    window.Kno = {
      kno_id: this.accountId,
      customer: {
        platform: 'CUSTOM',
        shop: window.location.host,
        email: leadPassenger.emailAddress,
        phone: `${leadPassenger.phoneNumber.internationalCode}${leadPassenger.phoneNumber.areaCode}${leadPassenger.phoneNumber.number}`,
      },
      order: {
        id: booking.bookingReference,
        total_price: priceBreakdown ? priceBreakdown.totalPrice : 0,
        currency: tripDetails.currency,
        line_items: priceBreakdown.knoCommerceProductsList,
      },
      survey: {
        selector: '.knoCommerce-modal-closeBtn',
      },
    }
  }

  renderPopup () {
    const surveyLoaded = !!document.querySelector('.kno-app.v-application')

    const hidePopup = this.hidePopup || !surveyLoaded

    return <div class={['knoCommerce-container', {'hide': hidePopup}]}>
      <div className={'o-centered-modal-wrapper'} onclick={() => {}}>
        <div data-test='knoCommerce-modal' className='o-centered-modal' onclick={(ev) => ev.stopPropagation()}>
          <div class='knoCommerce-modal-closeBtn' onclick={() => {this.hidePopup = true}}/>
        </div>
      </div>
    </div>
  }

  injectScript () {
    if (!isScriptLoaded(this.knoCommerceUrl)) {
      const knoCommerceScript = document.createElement('script')
      knoCommerceScript.type = 'text/javascript'
      knoCommerceScript.async = true
      knoCommerceScript.src = this.knoCommerceUrl
      document.head.appendChild(knoCommerceScript)
    }
  }
}
